// extracted by mini-css-extract-plugin
module.exports = {"cost-saving":"CostSaving_cost-saving__WsxKK"};